export function uriToId(uri?: string): string {
  const pieces = uri?.split('/') || [];
  return pieces[pieces.length - 1];
}
